<template>
    <div class="newList" v-if="indexList.length > 0">
        <div class="container">
            <div class="newList-banner">
                <div class="newList-banner-bg"></div>
                <component :is="swiper" :options="swiperOption" v-if="loadReady">
                    <component :is="swiperSlide" v-for="item in indexList" :key="item.scalePoolId">
                        <v-touch v-on:tap="testTap(item)" class="swiperCont">
                            <div class="newList-title">
                                {{item.name}}
                            </div>
                            <div class="newList-desc">{{item.shortDescribe}}</div>
                        </v-touch>
                    </component>
                    <div class="swiper-pagination" slot="pagination"></div>
                </component>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import {cutNum} from '../../../lib/units';

    export default {
        name: 'indexList',
        props: [
            'indexList',
            'type',
            'anchorTag'
        ],
        computed: {
            ...mapState([
                'channelId',
            ]),
            isItemDescTwoLine() {
                const that = this;
                let result = 0;
                that.indexList.map(item => {
                    if(item.name.length>8) {
                        result++;
                    }
                })
                return !!(result >0)
            }
        },
        data() {
            return {
                swiper: null,
                swiperSlide: null,
                loadReady: false,
                swiperOption: {
                    autoplay: 3000,
                    slidesPerView: 'auto',
                    paginationClickable: true,
                    loop: true,
                    pagination : '.swiper-pagination'
                }
            }
        },
        mounted() {
            if (this.anchorTag != '') {
                let anchorEl = document.querySelector('.indexList.' + this.anchorTag);
                if (anchorEl == undefined) {
                    return;
                } else {
                    document.body.scrollTop = anchorEl.offsetTop;
                }
            }
            ;
        },
        methods: {
            ...mapMutations([
                'setINDEXSCROLLTOP'
            ]),
            cutNum,
            timeTransform(time) {
                if (time == '' | time == undefined) {
                    return ''
                }
                let rs = '';
                let thatDay = new Date(time.replace(/-/g, '/'));
                let today = new Date();
                let c0 = function (num) {
                    return (num * 1) < 10 ? '0' + num : num;
                };
                if ((today.getFullYear() == thatDay.getFullYear()) & (today.getMonth() == thatDay.getMonth()) & (today.getDate() == thatDay.getDate())) {
                    if (today.getHours() == thatDay.getHours()) {
                        return ( c0(today.getMinutes()) - c0(thatDay.getMinutes()) ) + '分钟前';
                    } else {
                        return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes());
                    }
                } else {
                    return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate());
                }
                return rs;
            },
            testTap(testObj) {
                this.$emit('testClick', testObj, this.type);
            }
        },
        created() {
            domReadyPr.then(() => import('vue-awesome-swiper')).then(({swiper, swiperSlide}) => {
                this.loadReady = true;
                this.swiper = swiper;
                this.swiperSlide = swiperSlide;
            });
        }
    }
</script>

<style lang="scss">
    @import '../../../scss/function';

    @mixin limitLine($line) {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: $line;
    }

    .newList {
        position: relative;
        overflow: hidden;
        .container {
            margin: topx(30rem) 0 0 topx(40rem);
            overflow: hidden;
        }
        .mainTitle {
            margin-bottom: topx(10rem);
            &.pro {
                width: topx(230rem);
                height: topx(46rem);
                background: url('../../../assets/index/indexTitle_pro.png') no-repeat;
                background-size: cover;
            }
        }
        .sceTitle {
            margin-bottom: topx(20rem);
            font-size: topx(24rem);
            color: #999999;
            line-height: 1.1;

        }
        .swiper-container {
            margin-left: topx(-10rem);
            // margin-right: topx(20rem);
            width: topx(460rem);
            margin-left: topx(200rem);
            .swiper-slide {
                width: topx(460rem);
                border-radius: topx(10rem);
                margin-right: topx(15rem);
                height: topx(180rem);
                overflow: hidden;
                &:first-child {
                    margin-left: topx(0rem);
                }
                &:last-child {
                    margin-right: topx(15rem);
                }
            }
            .swiperCont {
                display: block;
                width: topx(460rem);
                margin: 0    topx(15rem) 0 topx(15rem);
                .imgCont {
                    position: relative;
                    width: topx(180rem);
                    height: topx(180rem);
                    box-sizing: border-box;
                    overflow: hidden;
                    margin-bottom: topx(8rem);
                    border-radius: topx(4rem);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .promotion-brand {
                        position: absolute;
                        z-index: 2;
                        top: topx(10rem);
                        left: topx(10rem);
                        width: topx(40rem);
                        height: topx(40rem);
                        background: url('../../../assets/promotion/icon-brand.svg') no-repeat;
                        background-size: cover;
                    }
                    .titleMask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0.3;
                        background: #000;
                    }

                }
                .desc {
                    font-weight: bold;
                    text-align: left;
                    // @include limitLine(2);
                    font-size: topx(26rem);
                    color: #333333;
                    letter-spacing: 0.13px;
                    line-height: topx(32rem);
                    min-height: topx(64rem);
                    width: topx(188rem);
                }
                .info {
                    overflow: hidden;
                    font-size: 0;
                    margin-top: topx(6rem);
                    .price {
                        float: left;
                        color: #FFA800;
                        line-height: 1;
                        font-weight: bold;
                        &.promotion {
                            color: #FF755B;
                        }
                        &.old-price {
                            margin-left: topx(10rem);
                            text-decoration: line-through;
                            font-size: 10px;
                            color: #999999;
                        }
                    }
                    .right {
                        float: right;
                        font-size: 20px * 0.5;
                        color: #999999;
                        line-height: 28px * 0.5;
                    }
                }
                .testedPeople {
                    font-size: topx(20rem);
                    color: #FFFFFF;
                    line-height: topx(20rem);
                    position: absolute;
                    width: topx(150rem);
                    height: topx(20rem);
                    left: topx(10rem);
                    bottom: topx(10rem);
                }
            }
        }
        .swiper-pagination-bullets{
            width: topx(500rem) !important;
            // right: topx(40rem) !important;
        }
        .swiper-pagination-bullet{
            width: topx(8rem) !important;
            height: topx(8rem) !important;
        }
        .swiper-pagination-bullet-active{
            background: #FFDD2B !important;
            width: topx(12rem) !important;
            height: topx(8rem) !important;
        }
        .pro-top{
            overflow: hidden;
            display: flex;
            margin-bottom: topx(40rem);
            .pro-box{
                width: topx(325rem);
                height: topx(182rem);
                overflow: hidden;
                border-radius: topx(10rem);
                background: #ccc;
                margin-right: topx(20rem);
                .title{
                    font-weight: bold;
                    text-align: center;
                    font-size: topx(28rem);
                    color: #FFFFFF;
                    line-height: topx(28rem);
                    text-shadow: 0 topx(1rem) topx(5rem) rgba(0,0,0,0.30);
                    margin-top: topx(65rem);
                }
                .tis{
                    font-size: topx(24rem);
                    color: #FFFFFF;
                    line-height: topx(24rem);
                    text-shadow: 0 topx(1rem) tox(5rem) rgba(0,0,0,0.30);
                    text-align: center;
                    margin-top: topx(10rem);
                }
            }
        }
        .newList-banner{
            position: relative;
            overflow: hidden;
            .newList-banner-bg{
                position: absolute;
                width: topx(670rem);
                height: topx(180rem);
                background: url('../../../assets/index/index-newtest.png') no-repeat center;
                background-size:100% 100%;
            }
            .newList-title{
                font-size: topx(38rem);
                color: #333333;
                line-height: topx(32rem);
                margin-top: topx(60rem);
                font-weight: bold;
                text-align: center;
                width: topx(450rem);
            }
            .newList-desc{
                font-size: topx(24rem);
                color: #999999;
                line-height: topx(20rem);
                margin-top: topx(15rem);
                text-align: center;
                width: topx(450rem);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/show/index/newSwiper.vue